import { Link } from 'react-router';
import "./Footer.scss";
import { FaInstagram, FaLinkedin, FaTiktok, FaGithub } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
         {/* CTA en bas du process */}
  <div className="process_cta">
    <h3>Parlons de votre besoin</h3>
    <p>
Création de site web : je vous accompagne
avec une solution adaptée à votre objectif.
</p>

    <div className="cta_buttons">
      <a 
        href="https://calendly.com/nouhaylaerrayssy99/30min" 
        target="_blank" 
        rel="noopener noreferrer"
        className="cta_primary"
      >
        Réserver un appel
      </a>
      <a 
        href="/contact"
        className="cta_secondary"
      >
        Demander un devis
      </a>
    </div>
  </div>

      {/* Socials */}
      <div className="footer__socials">
        <a href="https://www.instagram.com/erraysy_web_education/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <FaInstagram />
        </a>
        <a href="https://www.linkedin.com/in/nouhayla-er-raysy-996035210/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <FaLinkedin />
        </a>
    
        <a href="https://github.com/nouhaylaeraysy" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
          <FaGithub />
        </a>
      </div>

      {/* Quick Contact */}
      <div className="footer__contact">
        <p>📧 <a href="mailto:nouhaylaerrayssy99@gmail.com">nouhaylaerrayssy99@gmail.com</a></p>
        <p>📞 <a href="tel:+33758804874">+33 7 58 80 48 74</a></p>
      </div>
      {/* Liens légaux */}
      <div className="footer__legal">
        <Link to="/mentions-legales">Mentions légales</Link>
        <Link to="/politique-confidentialite">Politique de confidentialité</Link>
        <Link to="/conditions-generales-vente">CGV</Link>
      </div>
     

      {/* Copyright */}
      <div className="footer__copyright">
        © 2026 Er-Raysy Nouhayla Web . Tous droits réservés.
      </div>
    </footer>
  );
}